// kesikOkuma.js — KESİK OKUMA SESSİZ BAŞARI SAYILMAZ (6 Eki 2026)
//
// 🔑 Serkan'ın şartı (5 Eki 2026): *"FTL ve operasyonel kayıtlar için sistem, son 24 aylık dönemin tamamını
//    eksiksiz şekilde görüntüleyebilmeli, filtreleyebilmeli ve raporlayabilmelidir. Bu gereklilik Supabase'in
//    tek sorguda döndürdüğü kayıt sayısından bağımsız olarak sağlanmalıdır. 1000 kayıt sınırı kullanıcı
//    tarafından fark edilebilecek veri kaybına veya eksik rapora yol açmamalıdır."*
//
// 🔴 Sunucu (PostgREST) tek istekte en çok "Max rows" kadar satır döndürür ve fazlasını HATA VERMEDEN keser
//    (ayar 6 Eki 2026'da 1000 → 50000). Kesilen liste dolu bir liste gibi görünür: görevler kesilirse kümülatif
//    eksik sayılır ve pilot yasal görünür, uçuşlar kesilirse uçak saati ve istatistik eksik toplanır.
// 🔑 Büyük okuma `SAYILI` seçeneğiyle istenir: sunucu satırlarla birlikte TOPLAMI da söyler (Content-Range;
//    sayım aynı sorguda, aynı anlık görüntüde yapılır — araya giren kayıt yanlış alarm üretmez). Gelen satır
//    toplamdan azsa okuma KESİKTİR ve ekran onu, düşen okuma gibi, adıyla ve sayılarıyla söyler.
// ⚠️ Toplam gelmediyse (`count` sayı değil) karşılaştırma yapılamaz, kesik denmez. `SAYILI` istenen her
//    okumada sunucu toplamı döndürür (süper admin AIRPORTS sayaçları canlıda aynı yoldan çalışır); okumanın
//    `SAYILI` istediğini nöbetçi test (OkumaSiniri.test.js) kaynakta denetler.
// ⚠️ `.limit()`/`.range()` ile BİLEREK kısaltılmış okumada satır < toplam doğaldır — bu fonksiyon onlar için
//    değildir.

export const SAYILI = { count: 'exact' };

export const kesikMi = (sonuc) => !!sonuc && !sonuc.error && Array.isArray(sonuc.data)
  && typeof sonuc.count === 'number' && sonuc.data.length < sonuc.count;

export const kesikMetni = (sonuc) =>
  `incomplete — ${sonuc.data.length} of ${sonuc.count} records arrived (server row limit).`;

/** Tek mesaj gösteren ekranlar için (ör. kayıt geçmişi penceresi): düşen okumada sunucunun cümlesi, kesik okumada
 *  "1000 of 1250" metni, tam okumada null. Kural `okumaDenetimi` ile aynı (tek kaynak). */
export const okumaHataMetni = (sonuc) =>
  sonuc?.error ? (sonuc.error.message || String(sonuc.error)) : kesikMi(sonuc) ? kesikMetni(sonuc) : null;

/** SAYFALI okuma (3. adım) için: bir sayfa `.range(bas, bas + boy - 1)` ile istenir; gelmesi gereken satır sayısı
 *  min(boy, toplam − bas). Düşende sunucunun cümlesi, eksik sayfada sayılar, tamda null. Sayfanın satırı toplamdan
 *  az olduğu için `kesikMi` burada KULLANILMAZ (yanlış alarm olurdu). */
export const sayfaHataMetni = (sonuc, bas, boy) => {
  if (sonuc?.error) return sonuc.error.message || String(sonuc.error);
  if (typeof sonuc?.count !== 'number') return null;
  const beklenen = Math.max(0, Math.min(boy, sonuc.count - bas));
  const gelen = Array.isArray(sonuc.data) ? sonuc.data.length : 0;
  return gelen < beklenen ? `incomplete — ${gelen} of ${beklenen} records of this page arrived (server row limit).` : null;
};

/** Okuma kullanılamaz mı — düştü (`error`) ya da kesik geldi. Bölüm bölüm "bilinmiyor" diyen ekranlar (bildirim
 *  zili) bunu sorar; kutu çizen ekranlar `okumaDenetimi`ni kullanır. İkisi aynı tanım (tek kaynak). */
export const okunamadiMi = (sonuc) => !!sonuc?.error || kesikMi(sonuc);

/** Bir ekranın okumalarını denetler: `oku(ad, sonuc)` veriyi döndürür; düşen (`error`) ya da kesik okumayı
 *  `dustu`ya ADIYLA yazar (sunucunun kendi cümlesi / "1000 of 1250"). `dustu` doluysa ekran hesap göstermez,
 *  `OkumaHatasi` kutusu çizer. FTL paneli ve AIRCRAFTS aynı kuralı buradan çeker (tek kaynak). */
export const okumaDenetimi = () => {
  const dustu = [];
  const oku = (ad, sonuc) => {
    if (sonuc.error) dustu.push({ ad, metin: sonuc.error.message || String(sonuc.error) });
    else if (kesikMi(sonuc)) dustu.push({ ad, metin: kesikMetni(sonuc) });
    return sonuc.data;
  };
  return { dustu, oku };
};

// ── PARÇA PARÇA TAM OKUMA (6 Eki 2026, Serkan: "başlayalım devam") ─────────────────────────────────────────
// 🔑 Uyarı tek başına çözüm değildi — sunucu sınırına takılan okuma RETRY'da da aynı yerden kesilir. Hesap yapan
//    ekranlar büyüyen tabloyu PARÇA PARÇA okur: `PARCA` kadar ister, gelen satır kadar ilerler, toplam gelene
//    kadar devam eder. Sunucu ayarı ne olursa olsun (1000'e dönse de, daha da düşse de) veri TAM gelir.
//    Uyarı (`kesikMi`) son bekçi olarak kalır: okuma sürerken kayıt eklenir/silinirse sayılar tutmayabilir —
//    o zaman RETRY gerçekten işe yarar.
// 🔑 Sıra korunur: sorgunun kendi sıralamasının ARKASINA `id` eklenir (kütüphane sıralamaları birleştirir) —
//    eşit değerler kesin sıraya girer, sayfa sınırında satır kaymaz. Aynı kayıt iki sayfada görünürse (araya
//    kayıt girdi) bir kez alınır.
// ⚠️ `sorguUret` her çağrıda YENİ bir sorgu döndürür ve `SAYILI` ister (toplam her sayfada yeniden okunur).
// ⚠️ Bu, 3. adıma kadar KÖPRÜDÜR: tablonun tamamı okunur; büyüdükçe açılış uzar. 3. adım (tarih penceresi,
//    sayfalı liste, toplamı veritabanı yapar) yalnız gerekeni okutur.
export const PARCA = 1000;
const SAYFA_SINIRI = 1000;   // sonsuz döngüye karşı (1000 × 1000 satır); aşılırsa satır < toplam kalır, kesik söylenir

export async function hepsiniOku(sorguUret, { parca = PARCA, anahtar = 'id' } = {}) {
  const satirlar = [];
  const gorulen = new Set();
  let toplam = null;
  let bas = 0;
  for (let sayfa = 0; sayfa < SAYFA_SINIRI; sayfa++) {
    // Kütüphane hatayı çoğunlukla `{ error }` olarak DÖNDÜRÜR, ama ağ koparken bazı sürümlerde FIRLATIR — ikisi de
    // aynı sonuca bağlanır (düşen okuma), çağıran ekran ayrıca try/catch yazmak zorunda kalmaz (6 Eki 2026).
    let sonuc;
    try {
      sonuc = await sorguUret().order(anahtar, { ascending: true }).range(bas, bas + parca - 1);
    } catch (e) {
      return { data: null, error: { message: e?.message || String(e) }, count: null };
    }
    const { data, error, count } = sonuc;
    if (error) return { data: null, error, count: null };
    const gelen = Array.isArray(data) ? data : [];
    if (typeof count === 'number') toplam = count;
    for (const r of gelen) {
      const k = r?.[anahtar];
      if (k != null && gorulen.has(k)) continue;
      if (k != null) gorulen.add(k);
      satirlar.push(r);
    }
    bas += gelen.length;   // sunucu PARCA'dan az verirse (ayarı daha düşük) gelen kadar ilerlenir
    if (!gelen.length) break;
    if (toplam != null ? bas >= toplam : gelen.length < parca) break;
  }
  return { data: satirlar, error: null, count: toplam };
}
